import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useClinicOnboarding } from '@/hooks/useClinicOnboarding';

// Keeps a Clinic Owner with an active onboarding flow on /clinic-setup no
// matter which private route they try to jump to directly (typed URL, stale
// link, browser back/forward) - onboarding only ever unblocks once nextStep
// goes null (no active flow), at which point this guard has nothing to do.
// suppressRedirect:true opts out of the hook's own "no active flow ->
// /appointments" redirect here, since that only makes sense from the /clinic-setup page
// itself - an onboarding-complete owner must stay free to browse anywhere.
const ClinicOnboardingGuard = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { isClinicOwner, steps, nextStep } = useClinicOnboarding({ suppressRedirect: true });
  const isOnboardingInProgress = isClinicOwner && Array.isArray(steps) && Boolean(nextStep);

  useEffect(() => {
    if (isOnboardingInProgress && pathname !== '/clinic-setup') {
      navigate('/clinic-setup', { replace: true });
    }
  }, [isOnboardingInProgress, pathname, navigate]);

  if (isOnboardingInProgress) {
    return null;
  }

  return <Outlet />;
};

export default ClinicOnboardingGuard;
